<template>
  <div>
    <masthead title="Fresh, Crisp, <em>Vintriguing</em>"
              text="Indies of the UK; with a unique portfolio, efficient delivery and service you can count on,
               we welcome you to discover and order wine your customers will adore."
              background-image="products-masthead.jpg"/>
    <product-filter-list/>
    <order-steps/>
    <content-blocks ref="contentBlocks"/>
    <site-footer/>
  </div>
</template>

<script>
  import Masthead from '@/components/Masthead.vue'
  import SiteFooter from '@/components/SiteFooter.vue'
  import ProductFilterList from '@/components/ProductFilterList'
  import OrderSteps from '@/components/OrderSteps'
  import ContentBlocks from '@/components/ContentBlocks'

  export default {
    name: 'ProductsPage',
    components: {
      ContentBlocks,
      OrderSteps,
      ProductFilterList,
      Masthead,
      SiteFooter
    },
    data() {
      return {
        globalContent: null,
        pageContent: null
      };
    },
    methods: {
      loadPageContent: function () {
        this.$root.$api.getPageBySlug('global-content')
          .then(response => {
            if (response.data != null) {
              this.globalContent = response.data.pages[0];
              let contentPanels = [];

              this.globalContent.content.forEach(content => {
                if (content.name.includes('Excellence Panel')) {
                  contentPanels.push(content);
                }
              });

              this.$refs.contentBlocks.loadContent(contentPanels);
            }
          }).catch(error => {
          console.log(error);
        })
      },
    },
    created: function () {
      this.loadPageContent();
    }
  };
</script>
